define.alias("ember-cli-string-helpers/helpers/uppercase", "preview-grid/helpers/uppercase");